import EstimatedDateSetup from '@/components/EstimatedDateSetup';
import EstimatedTextCard from '@/components/EstimatedTextCard';
import RegularText from '@/components/RegularText';
import TestEditor from '@/components/TestEditor';
import CustomCard from '@/components/customCard';
import onboardingSlice, { onboardingSelector } from '@/redux/slice/onboarding.slice';
import { IRule } from '@/types/newSetup.type';
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface IProps {
  state: IRule;
  setState: (key: keyof IRule, value: string | number) => void;
}

const EditRule = (props: IProps) => {
  const dispatch = useDispatch();
  // const locationInfo = useSelector(locationInfoSelector);
  const onboarding = useSelector(onboardingSelector);

  // const { data: states } = locationApiCaller.useGetStatesQuery(
  //   { perPage: -1, countryCode: locationInfo?.data?.country_code },
  //   { skip: !locationInfo?.data?.country_code },
  // );

  // const locationData = useMemo(() => {
  //   return {
  //     countries: [
  //       { data: locationInfo?.data?.country_code || 'US', countryStateName: locationInfo?.data?.country_name || 'United States' },
  //     ],
  //     states: states?.data?.result.map((item) => ({ data: item.isoCode, countryStateName: item.name })) || [
  //       { data: 'NY', countryStateName: 'New York' },
  //     ],
  //     zipcode: locationInfo?.data?.zip_code || '00501',
  //   };
  // }, [locationInfo?.data?.country_code, locationInfo?.data?.country_name, locationInfo?.data?.zip_code, states?.data]);

  // const listLocationCondition = useMemo(() => {
  //   return [
  //     {
  //       title: 'Country',
  //       image: images.onboarding_country,
  //       selected: onboarding.locationConditionSelected === LocationConditionEnum.Country,
  //       onClick: () => {
  //         dispatch(
  //           onboardingSlice.actions.handleUpdateOnboarding({
  //             ...onboarding,
  //             locationConditionSelected: LocationConditionEnum.Country,
  //             rule: {
  //               ...onboarding.rule,
  //               locationConditions: [{ type: LocationConditionEnum.Country, value: locationData.countries }],
  //             },
  //           }),
  //         );
  //       },
  //     },
  //     {
  //       title: 'Zipcode',
  //       image: images.onboarding_zipcode,
  //       selected: onboarding.locationConditionSelected === LocationConditionEnum.Zipcode,
  //       onClick: () => {
  //         dispatch(
  //           onboardingSlice.actions.handleUpdateOnboarding({
  //             ...onboarding,
  //             locationConditionSelected: LocationConditionEnum.Zipcode,
  //             rule: {
  //               ...onboarding.rule,
  //               locationConditions: [{ type: LocationConditionEnum.Zipcode, value: [{ data: locationData.zipcode }] }],
  //             },
  //           }),
  //         );
  //       },
  //     },
  //     {
  //       title: 'State',
  //       image: images.onboarding_state,
  //       selected: onboarding.locationConditionSelected === LocationConditionEnum.State,
  //       onClick: () => {
  //         dispatch(
  //           onboardingSlice.actions.handleUpdateOnboarding({
  //             ...onboarding,
  //             locationConditionSelected: LocationConditionEnum.State,
  //             rule: {
  //               ...onboarding.rule,
  //               locationConditions: [
  //                 { type: LocationConditionEnum.Country, value: locationData.countries },
  //                 { type: LocationConditionEnum.State, value: locationData.states },
  //               ],
  //             },
  //           }),
  //         );
  //       },
  //     },
  //   ];
  // }, [onboarding, dispatch, locationData.countries, locationData.zipcode, locationData.states]);

  // const handleResetLocationCondition = () => {
  //   dispatch(
  //     onboardingSlice.actions.handleUpdateOnboarding({
  //       ...onboarding,
  //       locationConditionSelected: undefined,
  //       rule: { ...onboarding.rule, locationConditions: [] },
  //     }),
  //   );
  // };

  const handleSetError = useCallback(
    (msg: string) => {
      dispatch(onboardingSlice.actions.handleSetError({ status: !!msg, msg }));
    },
    [dispatch],
  );

  const handleBlurMessageText = useCallback(
    (value: string, styled_value?: string) => {
      handleSetError(styled_value?.trimStart() && props.state.estimatedText ? '' : 'This field is required');
      props.setState('name', value);
      props.setState('styledName', styled_value || '');
    },
    [handleSetError, props],
  );

  const handleChangeMessageText = useCallback(
    (_: string, styled_value?: string) => {
      onboarding.error.status && styled_value?.trimStart() && props.state.estimatedText && handleSetError('');
    },
    [handleSetError, onboarding.error.status, props.state.estimatedText],
  );

  const handleChangeTextInCart = useCallback(
    (_: string, styledValue?: string) => {
      handleSetError(styledValue?.trimStart() && (props.state.styledName || props.state.name) ? '' : 'This field is required');
      props.setState('estimatedText', styledValue || '');
    },
    [handleSetError, props],
  );

  return (
    <>
      {/* <div className="mb-12">
        <CustomCard badgeTop={<BoldText>PRO FEATURE PREVIEW</BoldText>}>
          <BoldText>Customize EDD by location</BoldText>
          <br />
          <RegularText>
            Try to add 1 condition. Your current location is auto-detected. This pro feature won't be saved.
          </RegularText>
          <div className="d-flex align-center gap-8">
            {listLocationCondition.map((item, index) => (
              <div key={index} className="w-full">
                <ButtonImageVertical
                  icon={<img width={'100%'} src={item.image} alt={item.title} />}
                  title={item.title}
                  selected={item.selected}
                  onClick={item.selected ? handleResetLocationCondition : item.onClick}
                  padding="0"
                  isShowRemove={item.selected}
                />
              </div>
            ))}
          </div>
        </CustomCard>
      </div> */}
      <CustomCard hasDroplist title={'Rule name'} required textClassName="text--blue bold-text-styled mb-8">
        <div className="mb-8">
          <RegularText>Name of delivery method, carrier, service type, or name for internal uses.</RegularText>
        </div>
        <TestEditor
          isRequired
          value={props.state.styledName || props.state.name || ''}
          onBlur={handleBlurMessageText}
          onChange={handleChangeMessageText}
          isHideTipsAndTemplate
          isHideVariableButton
          isHideAddImage
          onlyShowEmojiInIconButton
        />
      </CustomCard>

      <div className="mt-12">
        <EstimatedDateSetup
          isBlueTitle
          orderToShipDays={props.state.minPrepDays.toString()}
          onChangeOrderToShipDays={(newValue) => {
            props.setState('minPrepDays', +newValue);
          }}
          prepDays={props.state.maxPrepDays.toString()}
          onChangePrepDays={(newValue) => {
            props.setState('maxPrepDays', +newValue);
          }}
          shipToReceiveDays={props.state.minDeliveryDays.toString()}
          onChangeShipToReceiveDays={(newValue) => {
            props.setState('minDeliveryDays', +newValue);
          }}
          estDays={props.state.maxDeliveryDays.toString()}
          onChangeEstDays={(newValue) => {
            props.setState('maxDeliveryDays', +newValue);
          }}
        />
      </div>

      <div className="mt-12">
        <EstimatedTextCard isRequired isBlueTitle value={props.state.estimatedText || ''} onchange={handleChangeTextInCart} />
      </div>
    </>
  );
};

export default memo(EditRule);
